import { useSelector } from 'react-redux';
import { Library } from 'components';
import { getAllCategories, getCurrentEntryContent, getEntryContentButtonText, getNewContent } from 'redux/reducers';
import { hasSubscription } from 'redux/query';

import withSpinner from 'components/withSpinner';
import withLibrary from 'containers/withLibrary';

const LibraryContainer = () => {
  const categories = useSelector(getAllCategories);
  const entryContent = useSelector(getCurrentEntryContent);
  const entryContentButtonText = useSelector(getEntryContentButtonText);
  const isSubscribed = useSelector(hasSubscription);
  const newContent = useSelector(getNewContent);

  return (
    <Library
      categories={categories}
      entryContent={entryContent}
      hasSubscription={isSubscribed || false}
      entryContentButtonText={entryContentButtonText || 'Kurs starten'}
      newContent={newContent}
    />
  );
};

export default withLibrary(withSpinner(LibraryContainer));
